/// <reference path='../../interfaces/interfaces.d.ts' />
import functions = require('../../global/functions');

'use strict';

interface IButtonScope extends angular.IScope {
    buttonClicked: boolean;
}

class OrgListController {
    public static $inject = [
        '$http',
        '$scope',
        '$state',
        'toaster',
        'Orgs',
        'User',
        'bsLoadingOverlayService',
        '$uibModal',
        'Api',
        'Employee',
        'CrmService',
        'ReportService',
    ];

    public user;
    public orgs;
    public orgsArchived;
    public searchOrg;
    public searchEmployees;
    public searchValue;
    public searchOptions = ['Search for Employee by Name', 'Search for Employee by Email'];
    public searchOption = this.searchOptions[0];
    public wizardStatus;
    public externalUrl;
    public hasPermission;
    public currentPage = 1;

    public pageNums;
    public maxPageItems = 20;

    public cloneOrgInfo = {
        cloneOrgName: '',
        cloneHRMFirstName: '',
        cloneHRMLastName: ''
    };  
    public cloneSuccess: boolean = false;
    public cloneLogin = {
        cloneUsername: '',
        clonePassword: ''
    };

    public crmOrgList;

    public reviewIndex;
    public reviewOrgListCount = 0;
    public reviewSelected = false;
    public selectedReviewCompany;
    public allow_view_org = false;
    public allow_change_org = false;

    public reportCategory = [];
    public reportTitle = [];
    public reportDateRange = ['Yesterday', 'Last week', 'Last month', 'Last quater', 'All time', 'Custom'];
    public reportFilters = {
        reportCategory: '',
        reportTitle: '',
        dateRange: '',
        custom: {
            from: '---',
            to: '---'
        },
        organisation: '',
        includeArchived: ''
    };

    constructor(private $http: angular.IHttpService,
                private $scope: IButtonScope,
                private $state: ng.ui.IStateService,
                private toaster: any,
                private Org: IOrgsService,
                private User: IUserService,
                private bsLoadingOverlayService: IBsLoadingService,
                private $uibModal: any,
                private Api: any,
                private Employee: IEmpService,
                private CrmService: ICrmService,
                private ReportService: IReportService,
            ) {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        this.load();
        this.user = this.User;
        this.hasPermission = this.User.hasPermission;
        this.allow_view_org = this.hasPermission("org.view_org")
        this.allow_change_org = this.hasPermission("org.change_org")
        this.Employee.setQueryEmail('');
        this.Employee.setQuery('');
        this.cloneSuccess = false;
        this.crmOrgList = this.CrmService.getCrmOrgList();
        this.getReviewItems();
        this.outstandingReviewItems();
    }

    public load(): void {
        this.Org.getOrgs().then((orgs) => {
            this.bsLoadingOverlayService.start({referenceId: 'loader'});
            
            this.orgs = orgs;
            if (this.orgs.length > 0) {
                this.bsLoadingOverlayService.stop({referenceId: 'loader'});
            }
        }, () => {
            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
        });
        this.Org.getArchivedOrgs().then((orgs) => {
            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
            this.orgsArchived = orgs;
        }, () => {
            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
        });
        // this.Org.getWizardStatus().then((orgs) => {
        //     this.bsLoadingOverlayService.stop({referenceId: 'loader'});
        //     this.wizardStatus = orgs;
        // }, () => {
        //     this.bsLoadingOverlayService.stop({referenceId: 'loader'});
        // });
        this.bsLoadingOverlayService.start({referenceId: 'loader'});
        let lists: any = this.ReportService.getReportLists();
        this.externalUrl = functions.ExternalUrl;
        this.reportCategory = lists.category;
        this.reportTitle = lists.title;
        this.bsLoadingOverlayService.stop({referenceId: 'loader'});
    }

    public performSearch(): void {
        if (this.searchOption === this.searchOptions[0]) {
            this.Employee.setQuery(this.searchValue);
            this.Employee.setQueryEmail('');
            this.Employee.setQueryAllEmp(true);
            this.listEmployees();
            return;
        }
        if (this.searchOption === this.searchOptions[1]) {
            this.Employee.setQuery('');
            this.Employee.setQueryEmail(this.searchValue);
            this.Employee.setQueryAllEmp(true);
            this.listEmployees();
            return;
        }
    }

    public filterSearch(): void {
        if (this.searchValue.includes('@')) {
            this.searchOption = this.searchOptions[1];            
        }
    }

    public listEmployees = function (page: any = 1): void {
        this.currentPage = page;
        this.bsLoadingOverlayService.start({referenceId: 'emplist_loader'});
        this.Employee.list('', page).then(() => {
            this.bsLoadingOverlayService.stop({referenceId: 'emplist_loader'});
            if (this.searchOption === this.searchOptions[0] || this.searchOption === this.searchOptions[1]) {
                this.searchEmployees = this.Employee.getObject();
                this.pageNums = new Array(Math.ceil(this.searchEmployees.count / this.maxPageItems));
            }
            if (this.searchEmployees.count === 0) {
                this.toaster.pop('warning', 'Warning', 'No results matched the search term: ' + this.searchValue + '. Please try to use a different keyword.');
            }
        });
    };

    public archiveOrg(org: any): void {
        let modalInstance: any = this.$uibModal.open({
            templateUrl: '/static/templates/modals/confirmation_modal.html',
            controller: ['$scope', '$uibModalInstance', function ($scope: any, $uibModalInstance: any): any {
                $scope.confirmation = false;
                $scope.modalHeader = 'Archive Organisation';
                $scope.modalDetail = 'This organisation will be archived.  Are you sure?';
                $scope.confirmButton = 'Archive organisation';
                $scope.cancelButton = 'Cancel';
                $scope.confirm = () => {
                    $scope.confirmation = true;
                    $uibModalInstance.close($scope.confirmation);
                };
                $scope.cancel = () => {
                    $scope.confirmation = false;
                    $uibModalInstance.close($scope.confirmation);
                };
            }]
        });
        modalInstance.result.then((result) => {
            if (result) {
                this.Org.getOrg(org.id).then((full_org) => {
                    full_org.extra['status'] = 'D';
                    this.saveOrg(full_org);
                });

            } else {
                this.toaster.pop('warning', 'Cancelled', 'No changes were made. Action cancelled by user');
            }
        });
    }

    public isTestOrg(org: any): boolean {
        if (org.extra['test_flag'] === undefined || org.extra['test_flag'] === null) {
            return false;
        }

        return org.extra['test_flag'];
    }

    public toggleTestFlag(org: any): void {
        let testFlag = false;
        if (org.extra['test_flag'] === undefined || org.extra['test_flag'] === null) {
            testFlag = false;
        } else {
            testFlag = org.extra['test_flag'];
        }

        // Toggle the flag
        testFlag = !testFlag;

        // Confirm that the user wants to toggle
        let modalInstance: any = this.$uibModal.open({
            templateUrl: '/static/templates/modals/confirmation_modal.html',
            controller: ['$scope', '$uibModalInstance', 'toaster', function ($scope: any, $uibModalInstance: any): any {
                $scope.confirmation = false;
                if (testFlag) {
                    $scope.modalHeader = 'Test Organisation: ' + org.name;
                    $scope.modalDetail = 'Flag the organisation as a test/demo organisation?';
                    $scope.confirmButton = 'Set as test-organisation';
                } else {
                    $scope.modalHeader = 'Normal Organisation: ' + org.name;
                    $scope.modalDetail = 'Remove the test flag from the organisation?';
                    $scope.confirmButton = 'Remove flag';
                }
                $scope.cancelButton = 'Cancel';
                $scope.confirm = () => {
                    $scope.confirmation = true;
                    $uibModalInstance.close($scope.confirmation);
                };
                $scope.cancel = () => {
                    $scope.confirmation = false;
                    $uibModalInstance.close($scope.confirmation);
                };
            }]
        });
        modalInstance.result.then((result) => {
            if (result) {
                this.Org.getOrg(org.id).then((full_org) => {
                    full_org.extra['test_flag'] = testFlag;
                    this.saveOrg(full_org);
                });
            } else {
                this.toaster.pop('warning', 'Cancelled', 'No changes were made. Action cancelled by user');
            }
        });

    }

    public unarchiveOrg(org: any): void {
        let modalInstance: any = this.$uibModal.open({
            templateUrl: '/static/templates/modals/confirmation_modal.html',
            controller: ['$scope', '$uibModalInstance', 'toaster', function ($scope: any, $uibModalInstance: any): any {
                $scope.confirmation = false;
                $scope.modalHeader = 'Restore Organisation';
                $scope.modalDetail = 'This organisation will be restored.  Are you sure?';
                $scope.confirmButton = 'Restore organisation';
                $scope.cancelButton = 'Cancel';
                $scope.confirm = () => {
                    $scope.confirmation = true;
                    $uibModalInstance.close($scope.confirmation);
                };
                $scope.cancel = () => {
                    $scope.confirmation = false;
                    $uibModalInstance.close($scope.confirmation);
                };
            }]
        });
        modalInstance.result.then((result) => {
            if (result) {
                this.Org.getArchivedOrg(org.id).then((full_org) => {
                    full_org.extra['status'] = 'A';
                    this.saveOrg(full_org);
                });
            } else {
                this.toaster.pop('warning', 'Cancelled', 'No changes were made. Action cancelled by user');
            }
        });
    }

    public deleteOrg(org: any): void {
        
        let modalInstance: any = this.$uibModal.open({
            templateUrl: '/static/templates/modals/confirmation_modal.html',
            controller: ['$scope', '$uibModalInstance', 'toaster', function ($scope: any, $uibModalInstance: any): any {
                $scope.confirmation = false;
                $scope.modalHeader = 'Delete Organisation';
                $scope.modalDetail = 'All this organisation data will be deleted.  Are you sure?';
                $scope.confirmButton = 'Delete organisation';
                $scope.cancelButton = 'Cancel';
                $scope.confirm = () => {
                    $scope.confirmation = true;
                    $uibModalInstance.close($scope.confirmation);
                };
                $scope.cancel = () => {
                    $scope.confirmation = false;
                    $uibModalInstance.close($scope.confirmation);
                };
            }]
        });
        modalInstance.result.then((result) => {
            if (result) {
                this.Org.getArchivedOrg(org.id).then((full_org) => {                    
                    full_org.extra['status'] = 'D';   
                                 
                    this.deleteOrgAction(full_org.id);
                    
                });
            } else {
                this.toaster.pop('warning', 'Cancelled', 'No changes were made. Action cancelled by user');
            }
        });
    }

    private saveOrg(org: any): void {
        this.bsLoadingOverlayService.start({referenceId: 'loader'});
        let url: any ='/api/org';
        this.$http.put(url, this.Api.stripRestangular(org)).then((org) => {
            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
            this.load();
        }, (response: any) => {
            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
            if (response.status === 403) {
                this.toaster.pop('error', 'Access Denied', response.data.detail);
            } else if (response.status === 400) {
                this.toaster.pop('warning', 'Validation Failed', response.data[0] || response.data);
            } else {
                this.toaster.pop('error', 'Server error', 'Please, try again later');
            }
        });
    }

    
    private deleteOrgAction(orgID: string): void {
        
        this.Org.deleteOrg(orgID);/*.then(() => {
            this.toaster.pop('success', 'Success', 'Employee Activated');
        }, () => {
            this.toaster.pop('error', 'Error', 'There was an error processing your request');
        });*/      
       
    }

    public addOrg(): void {
        let modal_instance: any = this.$uibModal.open({
            templateUrl: '/static/templates/admin/org_add_modal.html',
            controller: ['$scope', '$uibModalInstance', '$http', 'toaster', ($scope, $uibModalInstance, $http, toaster) => {
                $scope.org = {
                    name: '',
                    admin_first_name: '',
                    admin_last_name: '',
                    admin_email: '',
                    extra: {}
                };
                $scope.submit = () => {
                    $scope.buttonClicked = true;
                    this.bsLoadingOverlayService.start({referenceId: 'loader'});
                    $scope.$broadcast('schemaFormValidate');
                    $http.post('/api/orgs', $scope.org).then(() => {
                        toaster.pop('success', 'Org Added');
                        $uibModalInstance.close($scope.org);
                    }, (response) => {
                        $scope.buttonClicked = false;
                        this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                        if (response.status === 400) {
                            toaster.pop('error', 'Validation Failed', response.data);
                        } else if (response.data.indexOf('User with this Email already exists.') !== -1) {
                            toaster.pop('error', 'Email Invalid', 'User with this Email already exists.');
                        } else {
                            toaster.pop('error', 'Server Error', 'Please try again');
                        }
                    });
                };
            }],
        });
        modal_instance.result.then(() => {
            this.load();
        });
    }

    public validateClone (form: angular.IFormController): any {
        if (form.$valid) {
            this.startClone();
        } else {
            this.toaster.pop('error', 'Please fill out all the fields.');
        }
    }

    public startClone(): any {
        this.bsLoadingOverlayService.start({referenceId: 'loader'});
        let orgInfo: any  = this.cloneOrgInfo;
        let loginInfo: any;
        this.Org.createOrgClone(orgInfo).then((response) => {
            response =  {
                username: 'test@test.test',
                password: 'password'
            };
            loginInfo = response;
            this.cloneLogin.cloneUsername = loginInfo.username;
            this.cloneLogin.clonePassword = loginInfo.password;
            // refresh the org list so the clone appears
            this.Org.getOrgs().then((orgs) => {
                this.orgs = orgs;
            }, () => {
                this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                this.toaster.pop('error', 'Server Error', 'Unable to refresh Organisation list. Please login again.');
            });
            // clear the form and show password and email.
            this.cloneOrgInfo = {
                cloneOrgName: '',
                cloneHRMFirstName: '',
                cloneHRMLastName: ''
            };
            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
            this.toaster.pop('success', 'Clone organisation added.');
            this.cloneSuccess = true;
        }, (response) => {
            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
            if (response.status === 400) {
                this.toaster.pop('error', 'Connection Error failed');
                } else {
                this.toaster.pop('error', 'Error creating the organisation clone');
                }
        });
    }

    public resetClone(): void {
        this.cloneOrgInfo = {
            cloneOrgName: '',
            cloneHRMFirstName: '',
            cloneHRMLastName: ''
        }; 
        this.cloneLogin = {
            cloneUsername: '',
            clonePassword: ''
        };
        this.cloneSuccess = false;
    }

    // TODO: this is a test function that returns hard-coded data from the service. Must be replaced with real calls.
    public getReviewItems(): any {
        let id: any = 'df2d2c4f-4698-4a1b-aaa2-df68f4ac26f7';
        this.CrmService.getOrgPreview(id);
        return this.crmOrgList;
    }

    // TODO: this is a test function that returns hard-coded data from the service. Must be replaced with real calls.
    public outstandingReviewItems(): any {
        // get count of outstanding review items and show count as badge on review tab
        this.reviewOrgListCount = this.crmOrgList.length;
    }

    // TODO: this is a test function that returns hard-coded data from the service. Must be replaced with real calls.
    public reviewReject(): void {
        // will call a service to say that the specific org has no matching CRM orgs
        let orgId: any = this.crmOrgList[this.reviewIndex].orgId;
        let crmLink: any = this.selectedReviewCompany;
        this.CrmService.rejectReview(orgId, crmLink);
    }

    public reviewAccept(): void {
        let orgId: any = this.crmOrgList[this.reviewIndex].orgId;
        let crmLink: any = this.selectedReviewCompany;
        this.CrmService.acceptReview(orgId, crmLink);
    }

    public previewOrg(): void {
        let that: any = this;
        let modal_instance: any = this.$uibModal.open({
            templateUrl: '/static/templates/admin/org_review_crm_modal.html',
            controller: ['$scope', '$uibModalInstance', '$http', 'toaster', 
            function ($scope: any, $uibModalInstance: any, $http: any, toaster: any): any {                
                $scope.orgList = that.crmOrgList;
                $scope.orgView = that.reviewIndex;
            }],
        });
        modal_instance.result.then(() => {});
    }

    public requestReport(params: any): any {
        this.bsLoadingOverlayService.start({referenceId: 'loader'});
        if (params.$valid) {
            if (this.reportFilters.dateRange !== 'Custom') {
                this.reportFilters.custom = {
                    from: '---',
                    to: '---'
                };
            }
            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
            this.ReportService.requestReport(this.reportFilters);
            this.toaster.pop('success', 'Your report will be downloaded shortly');
            params.$setPristine();
            params.$setUntouched();
            this.reportFilters = {
                reportCategory: '',
                reportTitle: '',
                dateRange: '',
                custom: {
                    from: '---',
                    to: '---'
                },
                organisation: '',
                includeArchived: ''
            };
        } else {
            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
            this.toaster.pop('warning', 'Warning', 'Please check the form and try again.');
        }
    }
}

angular.module('beneple.admin').controller('OrgListController', OrgListController);



// WEBPACK FOOTER //
// ./frontend/scripts/admin/controllers/org_list.ts